import { create, v } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { focus } from '@dojo/framework/core/middleware/focus';
import { Keys } from './keys';

export interface InlineTriggerPopupProperties {
	key: string;
}

export interface InlineTriggerPopupChildren {
	trigger(toggleOpen: () => void): any;
	content(onClose: () => void): any;
}

interface InlineTriggerPopupIcache {
	open: boolean;
}

const icache = createICacheMiddleware<InlineTriggerPopupIcache>();
const factory = create({ icache, focus })
	.properties<InlineTriggerPopupProperties>()
	.children<InlineTriggerPopupChildren[]>();

export const InlineTriggerPopup = factory(function ({ properties, children, middleware: { icache, focus } }) {
	const { key } = properties();
	const isOpen = icache.getOrSet('open', false);

	function toggleOpen() {
		icache.set('open', !isOpen);
	}

	function close() {
		icache.set('open', false);
		focus.focus();
	}

	const [{ trigger, content }] = children();

	return v(
		'div',
		{
			key,
			onkeydown: (event) => {
				switch (event.key) {
					case Keys.Escape:
						if (isOpen) {
							event.stopPropagation();
							close();
						}
				}
			}
		},
		[trigger(toggleOpen), isOpen ? content(close) : null]
	);
});

export default InlineTriggerPopup;
